'use client';

import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import styles from '@/styles/combo.module.scss';
import Navbar from '@/components/navbar';
import { useTranslations } from 'next-intl';
import moment from 'moment-timezone';

import useStore from '@store/index';
import PreloaderComponent from '../preloader';
import { Button, Carousel, Form } from 'react-bootstrap';
import { Edit2, Minus, MoreVertical, Plus, Settings, X } from 'react-feather';
import CustomizeSelector from '../modals/customizeSelector';
import { ItemObj, OrderDetails, PaidPayObj } from '../modals/order-details-sheet';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { encryptData, formatCurrency, modifiersFilter, notesCharLimit, removeSpacesFromString } from '_services/common.service';
import { OrderServeDetails } from '@store/slices/orderActions';
import { alertService } from '_services/alert.service';
import { loadingService } from '_services/loading.service';
import { CommonResponse, submitCollection, submitSets } from '_services/submit.service';
import { CartDetails } from './cart';
import ModalWrapperSheet from '../modals/cart-success-sheet';
import { useRouter } from 'next/navigation';
import cartsuccessstyles from '@/components/modals/cart-success-sheet.module.scss';
import itemAdded from '@/assets/lotties/item_added.json';
import Link from 'next/link';
import Lottie from 'lottie-react';
import { RemoveScroll } from 'react-remove-scroll';
import { Modifier, ModifierOption, Variation } from './itemview';
import { BiCircle } from 'react-icons/bi';
import { IoMdResize } from 'react-icons/io';
import CustomTooltip from '../common/customtooltip';
import RichTextViewer from '../common/richtextviewer';
import { event } from '@lib/ga';
import ItemView from '@/components/pages/itemview';
import { Category } from '../catelog/category-card';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
import PizzaOptionSkeleton from '../skeletons/pizza-option-skeleton';
import axios from 'axios';


export interface ComboImageObj {
  id: number,
  image_name: string,
  image_url: string,
  is_primary: boolean,
  status: string
}

export interface ComboOptionObj{
  optionId: number,
  optionDescription: string,
  optionOrder: number,
  items: ItemObj[],
  requirdSelection: number,
  minSelection: number,
  maxSelection: number
}

export interface ComboObject {
  dealId: number,
  dealName: string,
  description: string,
  dealCategory: string,
  images: ComboImageObj[],
  options: ComboOptionObj[],
  quantity: number,
  salePrice: {
    amount: number,
    currency: string
  }
  amount: {
    amount: number,
    currency: string
  },
  halfAndHalfFee: {
    amount: number,
    currency: string
  },
  amountType: string,
  applyMode: string,
  isSoldOut: boolean,
  isUpdate: boolean,
  isDelete: boolean,
  applyHalfAndHalfFeeOnce: boolean,
  allowOrderItemQuantities?: boolean | null;
  orderItemMaxQuantity?: number | null;
  discountApplyScope?: string | null;
}

interface BottomSheetProps {
  show: boolean;
  showHeader: boolean;
  onHide: () => void;
  onReset: () => void;
  title: string;
  children: React.ReactNode;
}

interface ErrorQueueItem {
  type: 'soldOut' | 'minSelection';
  message: string;
  itemId: string;
  modifierId?: string;
  button?: {
    text: string;
    onClick: () => void;
    className: string;
  };
}

const BottomSheet = ({ show,showHeader, onReset, title, children }: BottomSheetProps) => {
  const t = useTranslations();

  return (<>
    {show && <div className={show ? styles.bottomSheetBackdrop + ' ' + styles.showBottomSheetBackdrop : styles.bottomSheetBackdrop}></div>}

    <div className={`${styles.bottomSheet} ${show ? styles.show : ''}` + (!showHeader ? ` ${styles.comboHalfItem}` : '')}>
      <div className={styles.sheetHeader}>
        <h2 className={styles.sheetTitle}>{title.substring(0,55) + (title?.length > 55? '...' : '')}</h2>
        {showHeader &&<button className={styles.resetButton} id={`combo-bottom-sheet-reset-button`} onClick={onReset}>{t("ItemView.RESET")}</button>}
      </div>
      {children}
  </div>
  </>)};

export default function ComboComponent({
  comboItemObj,
  isBottomSheet,
  toggleBottomSheet
}: {
  comboItemObj: ComboObject | null,
  isBottomSheet: boolean,
  toggleBottomSheet: unknown
}) {
  const t = useTranslations();
  const router = useRouter();

  const [showPizzaSheet, setShowPizzaSheet] = useState(false);
  const [pauseNextStep, setPauseNextStep] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);
  const [showingTabId, setShowingTabId] = useState<string>('');
  const [showSuccessSheet, setShowSuccessSheet] = useState(false);

  const [selectedOptionIndex, setSelectedOptionIndex] = useState<number | null>(null);
  const [selectedOption, setSelectedOption] = useState<ComboOptionObj | null>(null);
  const [selectedOptionItem, setSelectedOptionItem] = useState<ItemObj | null>(null);

  const { hasHydrated, identityToken, cart, addToCart, companyDetails } = useStore((state) => state);

  const [selectedComboItem, setSelectedComboItem] = useState<ComboObject | null>(null);

  const [ isComboCompleted, setIsComboCompleted ] = useState<boolean>(false);
  const [ additionalFee, setAdditionalFee ] = useState<number>(0);
  const [ isComboOption, setIsComboOption ] = useState<boolean>(false);
  const [ isComboHalf, setIsComboHalf ] = useState<boolean>(false);
  const [ showAlert, setShowAlert ] = useState<boolean>(false);
  const [ subtotalPrice, setSubtotalPrice ] = useState<number>(0);
  const [ comboDiscount, setComboDiscount ] = useState<number>(0);
  const [ missingEitherSideCount, setMissingEitherSideCount ] = useState<number>(0);
  // const [ fixedModifierTotal, setFixedModifierTotal ] = useState<number>(0);
  const [ totalPrice, setTotalPrice ] = useState<number>(0);
  const [showDescriptionIndex, setShowDescriptionIndex] = useState<number | null>(null);
  const [initialComboItem, setInitialComboItem] = useState<ComboObject | null>(null);

  const [inputOnFocus, setInputOnFocus] = useState(false);
  const showCustomizeRef = useRef(showCustomize);

  // Add this state to track the error queue
  const [errorQueue, setErrorQueue] = useState<ErrorQueueItem[]>([]);
  const [currentErrorIndex, setCurrentErrorIndex] = useState(0);
  const [showError, setIsShowError] = useState(false);
  const showErrorRef = useRef(false);
  const [validErrorCount, setValidErrorCount] = useState(0);

  // Cache for loaded option items details - tracks which options have been loaded
  const [loadedOptionIds, setLoadedOptionIds] = useState<Set<number>>(new Set());
  const [isLoadingPizzaSheetItems, setIsLoadingPizzaSheetItems] = useState<boolean>(false);

  const [itemNotes, setItemNotes] = useState<Record<string, string>>({});
  const [activeNoteInput, setActiveNoteInput] = useState<string | null>(null);
  const [currentNote, setCurrentNote] = useState('');

  const defaultOrderDetails = () => ({
    orderId: "",
    orderVersion: 0,
    locationId: "",
    customerId: identityToken || "",
    lineItems: [] as ItemObj[],
    fulfillments: [] as OrderServeDetails[],
    payments: [] as PaidPayObj[],
    isDealItem: true,
    dealId: selectedComboItem?.dealId || 0,
    isUpdate: false,
    isDelete: false,
    } as OrderDetails);

    useEffect(() => {
      
      if (comboItemObj) {
        const updateComboItemObj = structuredClone(comboItemObj);

        updateComboItemObj?.options?.forEach((option, index) => {
          option.items?.forEach((item, itemIndex) => {
            item.itemUniqueId = `${item.itemId}-${index}${itemIndex}`;

            item.modifiers?.forEach(modifier => {
              modifier.mofireOptions?.forEach(mofireOption => {
                  mofireOption.isApplied = (mofireOption?.isDefaultSelected || false);
              });
            });
          });
        });

        // Sort options based on optionOrder
        updateComboItemObj.options.sort((a, b) => a.optionOrder - b.optionOrder);
        
        // Sort option items based on sold out status (sold out items at the end)
        // Also check applied variation sold out status

        // updateComboItemObj.options.forEach(option => {
        //   option.items.sort((a, b) => {
        //     const aVariationSoldOut = a.variations.some(variation => variation.isApplied && variation.isSoldOut);
        //     const bVariationSoldOut = b.variations.some(variation => variation.isApplied && variation.isSoldOut);
        //     if (aVariationSoldOut && !bVariationSoldOut) return 1;
        //     if (!aVariationSoldOut && bVariationSoldOut) return -1;
        //     if (a.isSoldOut === b.isSoldOut) return 0;
        //     return a.isSoldOut ? 1 : -1;
        //   });
        // });

        updateComboItemObj.options.forEach(option => {
        if (option?.items && Array.isArray(option.items)) {
          option.items.sort((a, b) => {
            const aVariationSoldOut = a.variations?.some(variation => variation.isApplied && variation.isSoldOut) ?? false;
            const bVariationSoldOut = b.variations?.some(variation => variation.isApplied && variation.isSoldOut) ?? false;
            if (aVariationSoldOut && !bVariationSoldOut) return 1;
            if (!aVariationSoldOut && bVariationSoldOut) return -1;
            if (a.isSoldOut === b.isSoldOut) return 0;
            return a.isSoldOut ? 1 : -1;
          });
        }
      });

        // console.log(structuredClone(updateComboItemObj));
        if (!initialComboItem) {
          // console.log('set initial ComboItem',initialComboItem);
          setInitialComboItem(structuredClone(updateComboItemObj));
        }
        // console.log('test initial ComboItem', updateComboItemObj);
        setSelectedComboItem(updateComboItemObj);
        // setSelectedComboItem(initialComboItem ? initialComboItem :updateComboItemObj);
      }
    }, [hasHydrated]);

    // console.log('view updated ComboItem',selectedComboItem);
    // console.log('view initial ComboItem',initialComboItem);
    // console.log('errorQueue',errorQueue);
    

    useEffect(() => {
      if (selectedComboItem && selectedOptionItem) {
        const updatedItem = selectedComboItem.options
          .flatMap(option => option.items)
          .find(item => item.itemUniqueId === selectedOptionItem.itemUniqueId);
        
        if (updatedItem) {
          setSelectedOptionItem(updatedItem);
        }
      }
    }, [selectedComboItem]);

    useEffect(() => {
      showErrorRef.current = showError;
    }, [showError]);

    // Load option items details when Pizza Customization Sheet opens
    useEffect(() => {
      const loadOptionItemsDetails = async () => {
        if (!showPizzaSheet || !selectedOption || !selectedComboItem) {
          return;
        }

        // const cacheKey = `${selectedOption.optionId}-${selectedComboItem.dealId}`;

        if (loadedOptionIds.has(selectedOption.optionId)) {
          setIsLoadingPizzaSheetItems(false);
          return;
        }

        try {
          setIsLoadingPizzaSheetItems(true);
          
          const requestPayload = {
            optionId: selectedOption.optionId,
          };

          const handlerId = `dealOption:${(selectedComboItem?.dealName || '').replace(/\s+/g, '')}:${selectedOption.optionId}`;

          const response = await axios.post('/api/submit', {
            urlId: handlerId,
            callstat: submitCollection.loadDealOptionItemsDetails,
            cobj: requestPayload,
            showalerts: false,
            options: null
          });

          if (response && response.status === 200 && response.data && response.data.extra) {
            const itemsDetails = response.data.extra;
            const loadedItems = itemsDetails.items || itemsDetails;

            const optionIndex = selectedComboItem.options.findIndex(
              opt => opt.optionId === selectedOption.optionId
            );
            
            loadedItems.forEach((item: ItemObj, itemIndex: number) => {
              item.itemUniqueId = `${item.itemId}-${optionIndex}${itemIndex}`;

              item.modifiers?.forEach(modifier => {
                modifier.mofireOptions?.forEach(mofireOption => {
                  mofireOption.isApplied = (mofireOption?.isDefaultSelected || false);
                });
              });
            });

            // Sort items by sold out status (same as initial useEffect)
            loadedItems.sort((a: ItemObj, b: ItemObj) => {
              const aVariationSoldOut = a.variations?.some(variation => variation.isApplied && variation.isSoldOut) ?? false;
              const bVariationSoldOut = b.variations?.some(variation => variation.isApplied && variation.isSoldOut) ?? false;
              if (aVariationSoldOut && !bVariationSoldOut) return 1;
              if (!aVariationSoldOut && bVariationSoldOut) return -1;
              if (a.isSoldOut === b.isSoldOut) return 0;
              return a.isSoldOut ? 1 : -1;
            });

            const updatedOption = {
              ...selectedOption,
              items: loadedItems
            };
            setSelectedOption(updatedOption);

            // Also update in selectedComboItem for consistency
            const updatedComboItem = { ...selectedComboItem };
            if (optionIndex !== -1) {
              updatedComboItem.options[optionIndex].items = loadedItems;
              setSelectedComboItem(updatedComboItem);
            }

            setLoadedOptionIds(prev => new Set(prev).add(selectedOption.optionId));
          } else {
            alertService.warn(t('ItemView.FAILED_TO_LOAD_ITEMS'));
          }
        } catch {
          alertService.error(t('ItemView.ERROR_LOADING_ITEMS'));
        } finally {
          setIsLoadingPizzaSheetItems(false);
        }
      };

      void loadOptionItemsDetails();
    }, [selectedOption?.optionId]);

  // // Preload all option images
  // useEffect(() => {
  //   if (selectedComboItem?.options) {
  //     const preloadImages = async () => {
  //       const promises = selectedComboItem.options.flatMap(option =>
  //         option.items.map(item => {
  //           if (item?.imageUrls?.[0]?.imageUrl) {
  //             return new Promise<void>((resolve) => {
  //               const img = document.createElement('img');
  //               img.onload = () => resolve();
  //               img.onerror = () => resolve();
  //               img.src = item.imageUrls[0].imageUrl;
  //             });
  //           }
  //           return Promise.resolve();
  //         })
  //       );
  //       await Promise.all(promises);
  //     };

  //     void preloadImages();
  //   }
  // }, [selectedComboItem?.options]);

  // Update the ref whenever showCustomize changes
  useEffect(() => {
    showCustomizeRef.current = showCustomize;
  }, [showCustomize]);

  const handleSlideChange = (optionId: string, isHalfAndHalf: boolean, side: string) => {
    // console.log("handleSlideChange called", optionId, isHalfAndHalf, side);

    const modifierKey = side === "leftSideDetails" ? "half 1" : side === "rightSideDetails" ? "half 2" : null;
    if (!modifierKey) return;
    // Find the modifier directly
    const modifier = selectedOptionItem?.modifiers?.find(mod => 
      mod.modifierName.toLowerCase().includes(modifierKey)
    );
    if (!modifier) return;
    // Find and update the option
    const optionToApply = modifier.mofireOptions.find(opt => 
      opt.optionId.toString() === optionId
    );

    // Reset previously applied options if optionId is undefined
    if (optionId === "-1") {
      modifier.mofireOptions.forEach(opt => {
        opt.isApplied = false;
      });
      setSelectedOptionItem({ ...selectedOptionItem! });
      const updatedComboItem = { ...selectedComboItem! };
      if (selectedOptionItem) {
        updatedComboItem.options?.forEach(opt => {
          opt.items?.forEach(item => {
            if (item.itemUniqueId === selectedOptionItem.itemUniqueId) {
              item.modifiers = selectedOptionItem.modifiers;
            }
          });
        });
      }
      setSelectedComboItem(updatedComboItem);
      return;
    }

    if (!optionToApply) return;

    // Check if already applied (avoid redundant updates)
    // if (optionToApply.isApplied) return;

    // Update all options in this modifier
    modifier.mofireOptions.forEach(opt => {
      opt.isApplied = (opt.optionId.toString() === optionId);
    });

    // Trigger state update
    setSelectedOptionItem({ ...selectedOptionItem! });
    // Update combo item
    const updatedComboItem = { ...selectedComboItem! };
    if (selectedOptionItem) {
      updatedComboItem.options?.forEach(opt => {
        opt?.items?.forEach(item => {
          if (item.itemUniqueId === selectedOptionItem.itemUniqueId) {
            item.modifiers = selectedOptionItem.modifiers;
          }
        });
      });
    }

    setSelectedComboItem(updatedComboItem);
    // console.log("combo update", updatedComboItem);
};

  useEffect(() => {
    if (selectedComboItem) {
      const isDiscountItemwise = (selectedComboItem?.discountApplyScope ?? "") === "item_wise";
      const quantity = Number(selectedComboItem.quantity ?? 1);

      let modifierPrice = 0;
      let discount = 0;
      let calculatedAdditionalFee = 0;

      const totalSelectedHalfHalfQuantity = selectedComboItem.options
        .flatMap(option => option.items || [])
        .reduce((acc, item) => {
          const isHalfItem = item.categories?.some((cat: Category) => cat.categoryName?.toLowerCase().includes("half")) || false;
          if (!isHalfItem || !item.isApplied) {
            return acc;
          }

          return acc + Math.max(1, Number(item.quantity || 1));
        }, 0);

      const price: number = selectedComboItem.options.reduce((acc, option) => {
        const selectedItem = option?.items ? option.items.filter(item => item.isApplied) : [];
        
        const halfHalfItems = option?.items?.filter(item => {
          return item.categories?.some((cat: Category) => cat.categoryName?.toLowerCase().includes("half")) || false;
        }) || [];

        const selectedHalfHalfItems = halfHalfItems.filter(item => item.isApplied);

        if (selectedHalfHalfItems.length > 0) {
          if (selectedComboItem?.applyHalfAndHalfFeeOnce) {
            calculatedAdditionalFee = (selectedComboItem?.halfAndHalfFee?.amount ?? 0);
          } else {
            calculatedAdditionalFee = (selectedComboItem?.halfAndHalfFee?.amount ?? 0) * totalSelectedHalfHalfQuantity;
          }
        }

        let itemPrice = 0;

        if (selectedItem && selectedItem.length > 0) {
          for(let i=0; i<selectedItem.length; i++){
            const itemModCharges = (selectedItem[i]?.modifiers?.reduce((modAcc, mod) => {
              const appliedModifiers = mod?.mofireOptions?.filter(opt => opt.isApplied) || [];
              
              const modifierTotal = appliedModifiers.reduce((sum, selectedModifier) => {
                const price = (selectedModifier?.optionPrice?.amount || 0) * 
                              (parseFloat(selectedModifier?.quantity?.toString() || '1') > 0 
                                ? parseFloat(selectedModifier?.quantity?.toString() || '1') 
                                : 1);
                
                return sum + (price > 0 ? price : 0);
              }, 0);
              
              return modAcc + modifierTotal;
            }, 0) || 0);
            
            const itemQty = Number(selectedItem[i]?.quantity || 1);
            modifierPrice += itemModCharges * itemQty;

            const currentItemPrice = (selectedItem[i]?.variations?.filter(variation => variation.isApplied).map(variation => variation?.variationPrice?.amount || 0).reduce((a, b) => a + b, 0) || 0);
            const finalItemPrice = (currentItemPrice * itemQty);
            let finalItemDiscount = 0;

            if(isDiscountItemwise){
              if(selectedComboItem?.applyMode === "discount"){
                if(selectedComboItem?.amountType === "amount"){
                  finalItemDiscount = (currentItemPrice > 0 ? (Math.round(selectedComboItem?.amount?.amount || 0) * itemQty) : 0);
                } else{
                  finalItemDiscount = (currentItemPrice > 0 ? (Math.round((currentItemPrice / 100) * (selectedComboItem?.amount?.amount || 0)) * itemQty) : 0);
                }
              } else {
                const fixedAmount = Math.round(selectedComboItem?.amount?.amount || 0) * itemQty;
                finalItemDiscount = Math.max(0, currentItemPrice * itemQty - fixedAmount);
              }
            }

            discount += finalItemDiscount;
            itemPrice += finalItemPrice;
          }
        }

        return acc + itemPrice;
      }, 0);

      setAdditionalFee(calculatedAdditionalFee);

      let finalPrice = price;

      setIsComboCompleted(selectedComboItem.options.every(option => {
        const totalAppliedQuantity = (option?.items || []).filter(item => item.isApplied).reduce((acc, item) => acc + Number(item.quantity || 0), 0) || 0;
        return totalAppliedQuantity >= (option?.minSelection || 1);
      }));
      
      // Combo discount logic
      if(!isDiscountItemwise){
        if(selectedComboItem?.applyMode === "discount"){
          if(selectedComboItem?.amountType === "amount"){
            discount = (finalPrice > 0 ? (Math.round(selectedComboItem?.amount?.amount || 0) * quantity) : 0);
            finalPrice = finalPrice * quantity;
          } else{
            discount = (finalPrice > 0 ? (Math.round((finalPrice / 100) * (selectedComboItem?.amount?.amount || 0)) * quantity) : 0);
            finalPrice = finalPrice * quantity;
          }
        } else{
          const fixedAmount = Math.round(selectedComboItem?.amount?.amount || 0) * quantity;
          discount = Math.max(0, finalPrice * quantity - fixedAmount);
          finalPrice = finalPrice * quantity;
        }
      } else{
        discount = discount * quantity;
        finalPrice = finalPrice * quantity;
      }

      setComboDiscount(discount);
    
      const finalSubtotal = finalPrice + (modifierPrice * quantity);
      setSubtotalPrice(finalSubtotal > 0 ? finalSubtotal : 0);

      const fixModTotal = (finalSubtotal + calculatedAdditionalFee * quantity - discount);
      setTotalPrice(fixModTotal > 0 ? fixModTotal : 0);
    }
  }, [selectedComboItem, isComboOption, showCustomize, showPizzaSheet]);

  const handleSetSelectOption = (index: number,itemUniqueId:string,isShowCustomize: boolean = false) => {

    // const option = selectedComboItem?.options?.find(opt =>opt.items?.some(item => item.itemId === index)) || null;
    setSelectedOptionIndex(index);
    setShowingTabId("");

    if(isShowCustomize){
      const selectedOptionItem =
        selectedComboItem?.options
          ?.flatMap(option => option.items)
          ?.find(item => item.itemUniqueId === itemUniqueId) || null;

      // const selectedOptionItem = option?.items.find(item => item.itemId === index.toString()) || null;
      setSelectedOptionItem(selectedOptionItem);
      const isHalfAndHalf = selectedOptionItem?.categories?.some((cat: Category) => cat.categoryName?.toLowerCase().includes("half")) || false;
      if(isHalfAndHalf){
        setIsComboOption(true);
        // setIsComboOption(!showErrorRef.current);
        setIsComboHalf(true);
      }
      else{
        setShowCustomize(true);
      }
    } else{
      // Set the selected option before opening pizza sheet
      const option = selectedComboItem?.options[index] || null;
      setSelectedOption(option);
      setShowPizzaSheet(true);
    }
  };


  // console.log(selectedComboItem?.options);

  const handleQuantityChange = (change: number, index: number) => {
    const option = selectedComboItem?.options[selectedOptionIndex || 0];
    const totalAppliedQuantity = option?.items.filter(item => item.isApplied).reduce((acc, item) => acc + Number(item.quantity || 0), 0) || 0;
    // console.log(option, totalAppliedQuantity);
    
    if (option) {
      const item = option.items[index];
      if (item) {
        const newQuantity = Number(item.quantity || 0) + change;
        if (newQuantity >= 0 && (totalAppliedQuantity + change) <= option.maxSelection) {
          item.quantity = newQuantity;
          item.isApplied = newQuantity > 0;
          setSelectedComboItem({ ...selectedComboItem });
        }
      }
    }
  };

  const handleSetOptionItem = (index: number, isApplied: boolean) => {
    const option = selectedComboItem?.options[selectedOptionIndex || 0];
    
    if (option) {
      const item = option.items[index];
      if (item) {
        // If single selection, unselect all other items
        if((option?.maxSelection || 1) === 1){
          option.items.forEach(itm => {
            itm.isApplied = false;
            itm.quantity = 1;
          });
        }

        // Calculate total applied quantity
        const totalAppliedQuantity = option?.items.filter(item => item.isApplied).reduce((acc, item) => acc + Number(item.quantity || 0), 0) || 0;

        // if required selection count reached, desable another items and show error msg
        if(totalAppliedQuantity >= (option?.maxSelection || 1) && !item.isApplied){
          alertService.warn(t('ItemView.SELECTION_RESTRICT_NOTICE', { max: option.maxSelection }), 3000, true);
        }
        else{
          item.isApplied = isApplied;
          item.quantity = 1;
        }

        // console.log(selectedComboItem);

        setSelectedComboItem({ ...selectedComboItem });
      }
    }
  };

  
  const handleModifierChange = (optionId: string, index: number, isQuantityChange: boolean, applyValue: unknown) => {
    // console.log(optionId, index, isQuantityChange, applyValue, isSideUpdate);

    const option = selectedOptionItem?.modifiers?.find(mod => mod.modifierId.toString() === optionId);
    
    if (option) {
      const item = option.mofireOptions[index];
      if (item) {
        if (isQuantityChange) {
          item.quantity = (Number((item.quantity || 0)) + Number(applyValue));
          item.isApplied = (item.quantity > 0);
          
        } else {
          if(option.selectionType === "MULTIPLE"){
            const currentAppliedCount = option?.mofireOptions.filter(opt => opt.isApplied).length || 0;

            if(!item.isApplied && option.maxSelection > 0 && (currentAppliedCount >= option.maxSelection)){
              alertService.warn(t('ItemView.MODIFIER_SELECTION_RESTRICT_NOTICE', { max: option.maxSelection }), 3500, true);
              return
            }

            item.isApplied = (applyValue as boolean);
            // item.quantity = (item.isApplied ? (item.quantity > 0 ? (parseFloat(option.minSelection.toString()) > 0? option.minSelection : 1) : 1) : 0);
            
          } else{
            option.mofireOptions.forEach(opt => {
              if (opt.optionId !== item.optionId){
                opt.isApplied = false;
                opt.quantity = 1;
              }
            });
            item.isApplied = (applyValue as boolean);
            // item.quantity = (parseFloat(option.minSelection.toString()) > 0 ? option.minSelection : 1);
          }

        }

        // console.log(option);
        
        setSelectedOptionItem({ ...selectedOptionItem! });

        const updatedComboItem = { ...selectedComboItem! };
        updatedComboItem.options.forEach(opt => {
          opt.items.forEach(item => {
            if (item.itemUniqueId === selectedOptionItem?.itemUniqueId) {
              item = { ...selectedOptionItem! };
            }
          });
        });

        setSelectedComboItem(updatedComboItem);
      }
    }
  };
  
  /* const handleResetAllSelectedOption = () => {
    if (initialComboItem) {
      // console.log('initialComboItem',initialComboItem);
      setSelectedComboItem(structuredClone(initialComboItem));
    }
  }; */

  const handleResetSelectedOption = () => {
    const option = selectedOption;
    if (option) {
      option.items.forEach(item => {
        item.isApplied = false;
      });
      setSelectedOption({ ...option });

      const updatedComboItem = { ...selectedComboItem! };
      updatedComboItem.options.forEach(opt => {
        opt.items.forEach(item => {
          if (item.itemUniqueId === selectedOptionItem?.itemUniqueId) {
            item = { ...selectedOptionItem! };
          }
        });
      });

      setSelectedComboItem(updatedComboItem);
      // setShowPizzaSheet(false);
    }
  };

  const handleSetDealQuantity = (quantity: number) => {
    if (selectedComboItem) {
      setSelectedComboItem({ ...selectedComboItem, quantity });
    }
  };

  const loadCart = async (cartDetails: CartDetails, isNew: boolean = false) => {
      const cartRes = await submitSets(submitCollection.viewCartOrder, {
        orderId: cartDetails?.orderId || ""
      }, true, {});
      
      loadingService.loading(false);
      if (cartRes && cartRes.status && cartRes.extra) {
        addToCart(cartRes.extra);
  
        if (isNew) {
          setShowSuccessSheet(true);
        }
      } else {
        alertService.error(t('Cart.LOAD_FAILED'), 3000, true);
      }
  };

  const isModifierStillInvalid = (itemUniqueId: string, modifierId: string): boolean => {
    const item = selectedComboItem?.options
      .flatMap(opt => opt.items)
      .find(i => (i.itemUniqueId || i.itemId) === itemUniqueId);

    if (!item) return false;

    const mod = item.modifiers?.find(m => m.modifierId.toString() === modifierId.toString());
    if (!mod) return false;

    const appliedCount = mod.mofireOptions.filter((opt: ModifierOption) => opt.isApplied).length;
    return appliedCount < (mod.minSelection || 0);
  };

  const showErrorsSequentially = (errors: ErrorQueueItem[]) => {
    if (errors.length === 0) return;

    const stillInvalidErrors = errors.filter(err =>
      isModifierStillInvalid(err.itemId, err.modifierId || '')
    );

    if (stillInvalidErrors.length === 0) return;

    setErrorQueue(stillInvalidErrors);
    setCurrentErrorIndex(0);
    setValidErrorCount(stillInvalidErrors.length);

    const firstError = stillInvalidErrors[0];
    if (firstError.button) {
      firstError.button.onClick();
    }
  };

  useEffect(() => {
    if ((!showCustomize) && !pauseNextStep && errorQueue.length > 0 && currentErrorIndex < errorQueue.length) {

      let nextIndex = currentErrorIndex + 1;
      let skippedCount = 0;

      while (nextIndex < errorQueue.length) {
        const candidate = errorQueue[nextIndex];
        const stillInvalid = isModifierStillInvalid(candidate.itemId, candidate.modifierId || '');

        if (stillInvalid) {
          break;
        }
        skippedCount++;
        nextIndex++;
      }

      if (nextIndex < errorQueue.length) {
        setIsShowError(true);

        if (skippedCount > 0) {
          setValidErrorCount(prev => prev - skippedCount);
        }

        setTimeout(() => {
          setCurrentErrorIndex(nextIndex);
          const nextError = errorQueue[nextIndex];
          if (nextError.button) {
            nextError.button.onClick();
          }
        }, 250);
      } else {
        setErrorQueue([]);
        setCurrentErrorIndex(0);
        setIsShowError(false);
        setValidErrorCount(0);
      }
    }
  }, [showCustomize, errorQueue, currentErrorIndex, pauseNextStep, isComboOption]);

  const handleAddToCart = () => {
    if (selectedComboItem) {
      //validate all selections selected with required selection count
      const hasInsufficientSelection = selectedComboItem.options.some(option =>
        (option?.items || []).filter(item => item.isApplied).reduce((acc, item) => acc + Number(item.quantity || 0), 0) < (option?.minSelection || 1)
      );
      
      if(hasInsufficientSelection){
        alertService.error("Please select all required options.");
        return;
      }

      const updatedOrderDetails = structuredClone(defaultOrderDetails());

      if(cart && cart.orderId && cart.orderId !== ""){
        updatedOrderDetails.orderId = (cart?.orderId || "");
        updatedOrderDetails.orderVersion = (cart?.orderVersion || 0);
        updatedOrderDetails.locationId = (cart?.locationId || "");
        updatedOrderDetails.isDelete = false;
        updatedOrderDetails.isUpdate = true;
        updatedOrderDetails.fulfillments = [];
      } else{
        updatedOrderDetails.locationId = (companyDetails?.locationId || "");
      }

      updatedOrderDetails.customerId = identityToken || "";
      updatedOrderDetails.customerTimezone = moment.tz.guess() || "UTC";

      const comboQty = Number(selectedComboItem?.quantity ?? 1);

      // Collect all errors
      const errors: ErrorQueueItem[] = [];

      let isModifierError = false;
      let isModiferSoldOutError = false;
      updatedOrderDetails.lineItems = selectedComboItem.options.reduce((acc: ItemObj[], option) => {
        const selectedItems = option.items.filter(item => item.isApplied);
        if (selectedItems.length > 0) {

          selectedItems.forEach(item => {
            const newItem = { ...item };
            newItem.quantity = (item.quantity ?? 1) * comboQty;
            newItem.isUpdate = false;
            newItem.isDelete = false;
            newItem.modifiers = (item?.modifiers || []).map(mod => {

              // Validate sold out selected modifier options
              const isSelectedOptionsSoldOut = mod.mofireOptions.some((opt: ModifierOption) => opt.isApplied && opt.isSoldOut);
              if(isSelectedOptionsSoldOut){
                if(!isModiferSoldOutError){
                  alertService.error(t('ItemView.SELECTED_MODIFIER_SOLD_OUT_NOTICE_COMBO', { item: newItem.itemName, modiferName: mod.modifierName }), 4500, true);
                  isModiferSoldOutError = true;
                }
              }
              
              // Validate modifier minimum selection
              if((mod.minSelection || 0) > 0){
                const appliedCount = mod.mofireOptions.filter((option: ModifierOption) => option.isApplied).length;

                if(appliedCount < (mod.minSelection || 0)){
                  errors.push({
                    type: 'minSelection',
                    message: t('ItemView.MODIFIER_MIN_SELECTION_NOTICE_COMBO', { 
                      modifier: mod.modifierName, 
                      min: mod.minSelection, 
                      item: newItem.itemName 
                    }),
                    itemId: item?.itemUniqueId || item?.itemId,
                    modifierId: mod.modifierId,
                    button: {
                      text: `Add ${mod.modifierName}`,
                      onClick: () => {
                        handleSetSelectOption(-1, (item?.itemUniqueId || item?.itemId), true);
                        setShowingTabId(mod.modifierId);
                        setShowAlert(true);
                        // setShowCustomize(true);
                        // setIsComboOption(false);
                      },
                      className: 'custom-alert-button'
                    }
                  });
                  isModifierError = true;
                }
              }

              return({
                ...mod,
                mofireOptions: (mod?.mofireOptions || []).reduce((modAcc: ModifierOption[], opt) => {
                  if (opt.isApplied) {
                    opt.quantity = opt.quantity? (parseInt(opt.quantity.toString()) > 1 ? parseInt(opt.quantity.toString()) : 1) : 1;
                    modAcc.push(opt);
                  }
                  return modAcc;
                }, [])
              })
            });
            newItem.variations = (item?.variations || []).filter(variation => variation.isApplied);
            newItem.notes = itemNotes[item.itemUniqueId || item.itemId] || '';
            acc.push(newItem);
          });
        }
        return acc;
      }, []);

      // Show all errors sequentially
      if(errors.length > 0){
        showErrorsSequentially(errors);
        return;
      }
      
      if(isModifierError || isModiferSoldOutError){
        return;
      }

      // Add the selected combo item to the cart
      // console.log("Adding to cart:", updatedOrderDetails);

      loadingService.loading(true);
      submitSets(submitCollection.saveOrder, updatedOrderDetails, false, null, false).then((res: CommonResponse) => {
        // console.log('Order Save Response:', res);
        
        if (res && res.status) {
          // handleResetAllSelectedOption();

          if(res.extra){
            
            // let resData = cart;
            // resData.orderId = res.extra.orderId;
            // resData.orderVersion = res.extra.orderVersion;
            // resData.locationId = res.extra.locationId;
            // resData.lineItems = cart.lineItems.concat(updatedOrderDetails.lineItems);
  
            // addToCart(resData);
            loadCart(res.extra as CartDetails, true);
          }
  
          // setTimeout(() => {
          //   router.push('/cart');
          // }, 2000);
        } else {
          if(res && res.extra === "Maximum allowed quantity for this item is 10"){
            loadingService.loading(false);
            alertService.error(t('ItemView.ADD_TO_CART_FAILED_MAX_QUANTITY'), 3000, true);
          }else{
            loadingService.loading(false);
            alertService.error(t('ItemView.ADD_TO_CART_FAILED'), 3000, true);
          }

          event({
            action: 'add_to_cart_failed',
            category: 'error',
            label: `Add to Cart Failed: ${(res && res.message) || 'Unknown error'}`
          });

        }
      }).catch((error: ErrorOptions) => {
        loadingService.loading(false);
        console.error('Error saving order:', error);
        alertService.error(t('ItemView.ERROR_SAVING_ORDER'), 3000, true);
      });
    }
  };

  const totalPriceFormatted = () => {
    // const quantity = (parseFloat((selectedComboItem?.quantity || 1).toString()) || 1);
    const currency = selectedComboItem?.options?.[0]?.items?.[0]?.price?.currency || 'USD';
    return formatCurrency(totalPrice, currency);
  };

  // useEffect(() =>{
  //   totalPriceFormatted();
  //   console.log("totalPriceFormatted",totalPriceFormatted());
  // },[handleSlideChange , selectedComboItem])

  const resetSelectedOptionItem = () => {
    const updatedOptionItem = {
      ...structuredClone(selectedOptionItem!),
      modifiers: (selectedOptionItem?.modifiers || []).map((mod) => ({
        ...mod,
        mofireOptions: (mod.mofireOptions || []).map((opt) => ({
          ...opt,
          isApplied: (opt.isDefaultSelected || false)
          // isApplied: false
        }))
      }))
    };

    setSelectedOptionItem((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        modifiers: updatedOptionItem.modifiers
      } as ItemObj;
    });

    const updatedComboItem = { ...selectedComboItem! };
    updatedComboItem.options.forEach(opt => {
      opt.items.forEach(item => {
        if (item.itemUniqueId === updatedOptionItem?.itemUniqueId) {
          item.modifiers = updatedOptionItem.modifiers;
        }
      });
    });

    setSelectedComboItem({
      ...updatedComboItem
    });

  };

  // console.log("selectedComboItem",selectedComboItem);

  // const hasHalfSide1Applied = selectedComboItem?.options?.some(option =>
  //   option.items?.some(item =>
  //     modifiersFilter(item.modifiers || [], ["half1"]).some(
  //       (modifier: Modifier) =>
  //         modifier.mofireOptions.some(
  //           (option: ModifierOption) => option.isApplied
  //         )
  //     )
  //   )
  // ) || false
  // const hasHalfSide2Applied = selectedComboItem?.options?.some(option =>
  //   option.items?.some(item =>
  //     modifiersFilter(item.modifiers || [], ["half2"]).some(
  //       (modifier: Modifier) =>
  //         modifier.mofireOptions.some(
  //           (option: ModifierOption) => option.isApplied
  //         )
  //     )
  //   )
  // ) || false

  const hasHalfandHalf = selectedComboItem?.options?.some(option => 
    option.items?.some(item => 
      item.itemName?.toLowerCase().includes("half") && 
      item.isApplied === true
    )
  ) || false;

  // useEffect(()=>{

  //     const items = selectedComboItem?.options?.flatMap(o => o.items || []) || [];

  //     const halfItems = items.filter(item =>
  //       item.itemName?.toLowerCase().includes('half') && item.isApplied
  //     );

  //     const missingEitherSideCount = halfItems.filter(item => {
  //       const h1 = modifiersFilter(item.modifiers || [], ['half1']).some(mod =>
  //         mod.mofireOptions?.some(opt => opt.isApplied)
  //       );
  //       const h2 = modifiersFilter(item.modifiers || [], ['half2']).some(mod =>
  //         mod.mofireOptions?.some(opt => opt.isApplied)
  //       );
  //       return !h1 || !h2;
  //     }).length;

  //     setMissingEitherSideCount(missingEitherSideCount);

  //     console.log(hasHalfandHalf,missingEitherSideCount);

  // },[selectedComboItem]);

  useEffect(() => {
    const items = selectedComboItem?.options?.flatMap(o => o.items || []) || [];

    const appliedItems = items.filter(item => item.isApplied);

    let missingCount = 0;

    appliedItems.forEach(item => {
      if (!item.modifiers) return;

      const isHalfItem = item.itemName?.toLowerCase().includes('half');

      if (isHalfItem) {
        const h1 = modifiersFilter(item.modifiers, ['half1']).some(mod =>
          mod.mofireOptions?.some(opt => opt.isApplied)
        );
        const h2 = modifiersFilter(item.modifiers, ['half2']).some(mod =>
          mod.mofireOptions?.some(opt => opt.isApplied)
        );

        if (!h1) missingCount++;
        if (!h2) missingCount++;

      item.modifiers.forEach(mod => {
        if (mod.minSelection <= 0) return;

        const appliedCount =
          mod.mofireOptions?.filter(opt => opt.isApplied === true).length ?? 0;

        if (appliedCount < mod.minSelection) {
          const modName = mod.modifierName?.toLowerCase();
          if (isHalfItem && (modName?.includes('half 1') || modName?.includes('half 2'))) return;

          missingCount++;
        }
      });}
    });

    setMissingEitherSideCount(missingCount);

    // console.log(hasHalfandHalf, missingCount);
  }, [selectedComboItem]);

  const handleCustomizeClick = () => {

  // if (isComboHalf) {
  //   setIsComboHalf(true);
  // } else {
  //   setShowCustomize(true);
  // }
};

  const handleShowItemNote = (itemId: string) => {
    setCurrentNote(itemNotes[itemId] || ''); // pre-fill if note exists
    setActiveNoteInput(itemId);
  };

  const handleSaveNote = (itemId: string) => {
    if (!currentNote.trim()) {
      // If empty, remove the note
      setItemNotes(prev => {
        const updated = { ...prev };
        delete updated[itemId];
        return updated;
      });
    } else {
      setItemNotes(prev => ({ ...prev, [itemId]: currentNote.trim() }));
    }
    setCurrentNote('');
    setActiveNoteInput(null);
  };

  const handleNoteKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>, itemId: string) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSaveNote(itemId);
    }
    if (e.key === 'Escape') {
      setActiveNoteInput(null);
      setCurrentNote('');
    }
  };

  const handleDeleteNote = (itemId: string) => {
    setItemNotes(prev => {
      const updated = { ...prev };
      delete updated[itemId];
      return updated;
    });
  };

  const cartId = (cart && cart.orderId && cart.orderId !== ""? "?c=" + encryptData(cart.orderId) : "");

  // Calculate total applied quantity for the selected option
  const totalOptionAppliedQuantity = (selectedOption?.items || []).filter(item => item.isApplied).reduce((acc, item) => acc + Number(item.quantity || 0), 0) || 0;

  if (!hasHydrated) {
    return <PreloaderComponent />; // Prevent rendering until store is hydrated
  }

  // console.log("isComboHalf",isComboHalf);
  
  return (
  <RemoveScroll enabled={showCustomize || isBottomSheet ||showPizzaSheet || showSuccessSheet || isComboOption}>
    {!isBottomSheet && <Navbar pageTitle={selectedComboItem?.dealName || "Combo"} />}

    <div className={styles.comboPage + (inputOnFocus ? ` ${styles.inputOnFocus}` : '') + (isBottomSheet ? ' ' + styles.withOutNavbar : '')}>
      <div className={styles.comboContent}>
        
        {/* Item view back button */}
        <div style={{ display: isBottomSheet ? 'none' : 'block' }}>
          <Button variant='secondary' id={`item-view-go-back-button`} onClick={() => window.history.back()} className={styles.singleViewBackButton}><X size={20} /></Button>
        </div>

        <div className={styles.promoCard}>
        <div className={styles.promoContent}>
          <div className={styles.imageSection}>
            <div className={styles.imageWrapper}>
              <Carousel
                interval={null}
                className={styles.imageCarousel}
                
              >
                {selectedComboItem?.images && selectedComboItem?.images.length > 0 && selectedComboItem?.images.map((image: ComboImageObj, index: number) => (
                  <Carousel.Item key={index}>
                    <PhotoProvider>
                      <PhotoView src={image.image_url || 'assets/images/placeholder.png'}>
                        <Image
                          id={`combo-preview-image-${index}`}
                          src={image.image_url}
                          alt={image.image_name || 'combo meal'}
                          width={460}
                          height={476}
                          className={styles.itemImage}
                          placeholder='blur'
                          blurDataURL="/assets/images/placeholder.png"
                        />
                      </PhotoView>
                    </PhotoProvider>
                  </Carousel.Item>
                ))}
              </Carousel>

            </div>
            
          </div>
        </div>
      </div>

      {selectedComboItem?.isSoldOut && <div className={styles.soldOutBanner}>
        <p>{t('ItemView.SOLD_OUT_MESSAGE')}</p>
      </div>}

      <div className={styles.selectionArea}>

        {/* Description Section */}
        <div className={styles.contentSection}>
          {selectedComboItem?.description ? <p className={styles.description}>
            {selectedComboItem?.description}
          </p> : <></>}
        </div>

        {/* <button onClick={handleResetAllSelectedOption}>
          reset
        </button> */}

        {selectedComboItem && selectedComboItem.options && selectedComboItem.options.sort((a, b) => a.optionOrder - b.optionOrder).map((option, index) => {
          const totalAppliedQuantity = option?.items?.filter(item => item.isApplied).reduce((acc, item) => acc + Number(item.quantity || 0), 0) || 0;
          const remainingSelections = (option?.minSelection ?? 1) - totalAppliedQuantity;
          
          return(<div key={index} data-combooption={removeSpacesFromString(option.optionDescription)} className={styles.comboOption}>
            {index === 0 && selectedComboItem?.dealName && (
              <h1 style={{ position: 'absolute', left: '-10000px', width: '1px', height: '1px', overflow: 'hidden' }}>
                {selectedComboItem.dealName}
              </h1>
            )}
            <h3 className={styles.sectionTitle}>
              {option.optionDescription}
            
              {/* {option.requirdSelection === 1 && option.items && option.items.length > 0 && (option.items.find(item => item.isApplied)?.modifiers || []).length > 0 && (
                <Button 
                  variant='warning' 
                  id={`combo-option-${index}-customize-button`} 
                  className={styles.customizeButton} 
                  onClick={() => handleSetSelectOption(index, true)}
                  data-id="option-customize-button"
                  >
                  <Settings size={16} />
                </Button>
              )} */}
            </h3>
            <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
              {option.items && option.items.length > 0 && option.items.filter(item => item.isApplied).length > 0 ? 
                (option.items.filter(item => item.isApplied).map((item, itemIndex) => {
                  const isHalfAndHalf = (item?.modifiers || []).some((modifier: Modifier) => modifier.modifierName.toLowerCase().includes("half"));
                  return <div key={`combo-option-${index}-item-${itemIndex}-selected-button`} style={{ marginBottom: "10px" }}>
                  <div style={{display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px',gap: '1rem'}}>
                    {/* <button 
                      id={`combo-option-${index}-item-${itemIndex}-selected-button`} 
                      className={styles.dropdownSelector} 
                      onClick={() => handleSetSelectOption(index,'')}
                      data-id="option-select-button"
                      >
                      {item.itemName}
                    </button> */}
                    {item.itemName.length > 45 ? (
                      <CustomTooltip
                        overlayContent={item.itemName}
                        placement="top"
                        scrollElement={null}
                      >
                        <button 
                          id={`combo-option-${index}-item-${itemIndex}-selected-button`} 
                          className={styles.dropdownSelector} 
                          onClick={() => {
                            handleSetSelectOption(index,'');
                          
                            event({
                              action: 'combo_option_item_name_tooltip_viewed',
                              category: 'engagement',
                              label: `Combo Option Item Name Tooltip Viewed: ${item.itemName}`,
                            });
                          }}
                          data-id="option-select-button"
                          >
                          <span>{item.quantity} x {item.itemName.substring(0, 45) + "..."}</span>
                        </button>
                      </CustomTooltip>
                    ) : (
                      <button 
                          id={`combo-option-${index}-item-${itemIndex}-selected-button`} 
                          className={styles.dropdownSelector} 
                          onClick={() => {
                            handleSetSelectOption(index,'');
                            event({
                              action: 'combo_option_item_name_tooltip_viewed',
                              category: 'engagement',
                              label: `Combo Option Item Name Tooltip Viewed: ${item.itemName}`,
                            });
                          }}
                          data-id="option-select-button"
                          >
                          <span>{item.quantity} x {item.itemName}</span>
                        </button>
                    )}

                    {(
                      <span
                        id={`combo-option-${index}-item-${itemIndex}-note-button`}
                        className={styles.noteButton}
                        data-id="option-customize-button"
                      >
                        <CustomTooltip
                          overlayContent={t("ItemView.Note")}
                          placement="top"
                          scrollElement={null}
                        >
                          <Button
                            id={`item-view-note-button`}
                            className={styles.itemNote + ' ' + styles.top}
                            onClick={() => handleShowItemNote(item.itemUniqueId || item.itemId)} 
                            
                          >
                            <span><Edit2 size={16} /></span>
                          </Button>
                        </CustomTooltip>
                      </span>
                    )}

                    {item.modifiers && modifiersFilter((item?.modifiers || []), ['dietary','notdietary']).length > 0 &&<span 
                      id={`combo-option-${index}-item-${itemIndex}-customize-button`} 
                      className={styles.customizeButton} 
                      onClick={(e) => {
                        e.stopPropagation();
                        // handleSetSelectOption(itemIndex, true);
                        handleSetSelectOption(-1,(item?.itemUniqueId || item?.itemId), true);
                        
                        event({
                          action: 'combo_option_customize_button_clicked',
                          category: 'engagement',
                          label: `Combo Option Customize Button Clicked: ${item.itemName}`,
                        });
                      }}
                      data-id="option-customize-button"
                      >
                      {/* <Settings size={16} /> */}
                      <CustomTooltip
                        overlayContent={t("ItemView.CUSTOMIZE")}
                        placement="top"
                        scrollElement={null}
                      >
                        <Button variant='warning' id={`item-view-customize-button`} className={styles.customizeButton + ' ' + styles.top} onClick={handleCustomizeClick}>
                          {/* <Plus size={15} /> */}
                          <span><Settings size={16} /></span>
                        </Button>
                      </CustomTooltip>
                    </span>}
                  </div>

                  {/* Input area */}
                  {activeNoteInput === item.itemUniqueId && (
                    <div className={styles.optionGroup} style={{ marginTop: '16px' }}>
                      <textarea
                        autoFocus
                        className={styles.notesInput}
                        placeholder={t('ItemView.ADD_SPECIAL_INSTRUCTIONS')}
                        value={currentNote}
                        onChange={(e) => {
                          if (e.target.value.length > notesCharLimit) return;
                          setCurrentNote(e.target.value);
                        }}
                        onKeyDown={(e) => handleNoteKeyDown(e, item.itemUniqueId || item.itemId)}
                        onFocus={(e) => {
                          setInputOnFocus(true);
                          const length = e.target.value.length;
                          e.target.setSelectionRange(length, length);
                        }}
                        onBlur={() => {
                          setInputOnFocus(false);
                          handleSaveNote(item.itemUniqueId || item.itemId); 
                        }}
                      />
                      <div className={styles.charCount}>{currentNote.length}/{notesCharLimit}</div>
                    </div>
                  )}

                  {/* Saved note — only shown when textarea is closed */}
                  {activeNoteInput !== item.itemUniqueId && itemNotes[item.itemUniqueId || item.itemId] && (
                    <div className={styles.savedNoteRow}>
                      <div className={styles.savedNoteDetail}>
                        <span className={styles.savedNoteTitle}>{t('ItemView.ADDITIONAL_NOTES')} : </span>
                        <span className={styles.savedNoteText}>  {itemNotes[item.itemUniqueId || item.itemId]}</span>
                      </div>
                      <X size={16} onClick={() => handleDeleteNote(item.itemUniqueId || item.itemId)}/>
                    </div>
                  )}

                  {/* Show selected add-ons */}
                  {!isHalfAndHalf &&((item?.modifiers || []).length > 0 && (item?.variations || []).length > 0)?<> 
                    <div className={styles.selectedAddons} style={{ marginBottom: '5px' }}>
                      <div className={styles.addOnsList}>
                        {/* {item?.variations && item?.variations.length > 0 && (item?.variations || []).filter(variation => variation.isApplied).map((variation: Variation, varIndex: number) => {
                          return variation.variationName.length > 0 && <span key={varIndex} className={`${styles.addonItem} ${styles.base}`}>{variation.variationName.length > 0 && <IoMdResize size={12} />} <span> {variation.variationName.length > 0 && <span>{variation.variationName} {t("ItemView.SIZE")}</span>}

                            {!isHalfAndHalf && modifiersFilter((item?.modifiers || []), ['dietary']).map((modifier: Modifier) => {
                              const applied = modifier.mofireOptions.filter((modoption: ModifierOption) => modoption.isApplied && !modoption.isDefaultSelected);
                              // console.log(option);
                              return (
                                <React.Fragment key={modifier.modifierId}>
                                  {applied.length > 0 ? (
                                    <>{applied.map((opt: ModifierOption, index: number) => {
                                      return <span key={index}>{` (${opt.optionName})`}</span>;
                                    })}</>
                                  ) : null}
                                </React.Fragment>
                              );
                            })}
                            </span>
                          
                          </span>;
                        })} */}

                        {item?.variations && item.variations.length > 0 && item.variations
                          .filter(variation => variation.isApplied)
                          .map((variation: Variation, varIndex: number) => {
                            const appliedModifiers = modifiersFilter((item?.modifiers || []), ['dietary'])
                              .flatMap((modifier: Modifier) => 
                                modifier.mofireOptions.filter((modoption: ModifierOption) => 
                                  modoption.isApplied && !modoption.isDefaultSelected
                                )
                              );

                            const shouldRender = variation.variationName.length > 0 || appliedModifiers.length > 0;

                            if (!shouldRender) return null;

                            return (
                              <span key={varIndex} className={`${styles.addonItem} ${styles.base}`}>
                                {variation.variationName.length > 0 && (
                                  <>
                                    <IoMdResize size={12} />
                                    <span>
                                      {variation.variationName} {t("ItemView.SIZE")}
                                    </span>
                                  </>
                                )}

                                {!isHalfAndHalf && modifiersFilter((item?.modifiers || []), ['dietary']).map((modifier: Modifier) => {
                                  const applied = modifier.mofireOptions.filter(
                                    (modoption: ModifierOption) => 
                                      modoption.isApplied && !modoption.isDefaultSelected
                                  );

                                  return (
                                    <React.Fragment key={modifier.modifierId}>
                                      {applied.map((opt: ModifierOption, index: number) => (
                                        <span key={index}>{` (${opt.optionName})`}</span>
                                      ))}
                                    </React.Fragment>
                                  );
                                })}
                              </span>
                            );
                          })
                        }

                        {!isHalfAndHalf && modifiersFilter((item?.modifiers || []), ['base']).map((modifier: Modifier) => {
                          const applied = modifier.mofireOptions.filter((modoption: ModifierOption) => modoption.isApplied);
                          // console.log(option);
                          
                          return (
                            <React.Fragment key={modifier.modifierId}>
                              {applied.length > 0 ? (
                                <>{applied.map((opt: ModifierOption, index: number) => {
                                  return <span key={index} className={`${styles.addonItem} ${styles.base}`}><BiCircle size={16} /> {opt.optionName} {t("ItemView.BASE")}
                                  </span>;
                                })}</>
                              ) : null}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </div>
                  </> : <></>}

                  {!isHalfAndHalf && modifiersFilter((item?.modifiers || []), ['add', 'ingredient', 'removal']).filter(modifier => modifier.mofireOptions.some(option => option.isApplied)).length > 0 ?<>
                    <div className={styles.selectedAddons}>
                      <div className={styles.addOnsList}>
                        {modifiersFilter((item?.modifiers || []), ['add']).map((modifier: Modifier) => {
                          const applied = modifier.mofireOptions.filter((option: ModifierOption) => option.isApplied);
                          return (
                            <React.Fragment key={modifier.modifierId}>
                              {applied.length > 0 ? (
                                <>{applied.map((opt: ModifierOption, index: number) => {
                                  return <React.Fragment key={index}>
                                    <CustomTooltip
                                      overlayContent={opt.optionName || ''}
                                      placement="top"
                                      scrollElement={null}
                                    >
                                      <span className={styles.addonItem}>+ {opt.quantity > 1 ? `${opt.quantity} x ` : ''} {opt.optionName.substring(0, 20) + (opt.optionName.length > 20 ? '...' : '')}</span>
                                    </CustomTooltip>
                                  </React.Fragment>;
                                })}</>
                              ) : null}
                            </React.Fragment>
                          );
                        })}

                        {modifiersFilter((item?.modifiers || []), ['ingredient', 'removal']).map((modifier: Modifier) => {
                          const isIngredientModifier = modifier.modifierName.toLowerCase().includes("ingred");
                          const removed = modifier.mofireOptions.filter((option: ModifierOption) => (isIngredientModifier ? !option.isApplied : option.isApplied));

                          return (
                            <React.Fragment key={modifier.modifierId}>
                              {removed.length > 0 ? (
                                <>{removed.map((opt: ModifierOption, index: number) => {
                                  return <React.Fragment key={index}>
                                    <CustomTooltip
                                      overlayContent={opt.optionName || ''}
                                      placement="top"
                                      scrollElement={null}
                                    >
                                      <span className={`${styles.addonItem} ${styles.removable}`}>- {opt.quantity > 1 ? `${opt.quantity} x ` : ''} 
                                        {opt.optionName.substring(0, 20) + (opt.optionName.length > 20 ? '...' : '')}</span>
                                    </CustomTooltip>
                                  </React.Fragment>;
                                })}</>
                              ) : null}
                            </React.Fragment>
                          );
                        })}

                      </div>
                    </div>
                  </> : <></>}

                  {/* Show half and half selected add-ons side by side */}
                  {isHalfAndHalf? <>
                    {((item?.modifiers || []).length > 0 || (item?.variations || []).length > 0)?<> 
                      <div className={styles.selectedAddons} style={{ marginBottom: '5px' }}>
                        <div className={styles.addOnsList}>
                          {item?.variations && item?.variations.length > 0 && (item?.variations || []).filter(variation => variation.isApplied).map((variation: Variation, varIndex: number) => {
                            return <span key={varIndex} className={`${styles.addonItem} ${styles.base}`}>
                              <IoMdResize size={12} /> 
                              
                              <span>
                                {variation.variationName} {t("ItemView.SIZE")}
                                
                                {modifiersFilter((item?.modifiers || []), ['dietary']).map((modifier: Modifier) => {
                                  const applied = modifier.mofireOptions.filter((modoption: ModifierOption) => modoption.isApplied && !modoption.isDefaultSelected);
                                  // console.log(option);
                                  return (
                                    <React.Fragment key={modifier.modifierId}>
                                      {applied.length > 0 ? (
                                        <>{applied.map((opt: ModifierOption, index: number) => {
                                          return <span key={index}>{` (${opt.optionName})`}</span>;
                                        })}</>
                                      ) : null}
                                    </React.Fragment>
                                  );
                                })}
                              </span>

                            </span>;
                          })}

                          {modifiersFilter(item?.modifiers || [], ["half1"]).map((modifier: Modifier) => {
                            const applied = modifier.mofireOptions.filter((option: ModifierOption) => option.isApplied);
                            return (
                              <React.Fragment key={modifier.modifierId}>
                                {applied.length > 0 ? (
                                  <>{applied.map((opt: ModifierOption, index: number) => {
                                    return <span key={index} className={styles.addonItem}>{t("ItemView.LEFT_SELECTION")} {opt.optionName}</span>;
                                  })}</>
                                ) : null}
                              </React.Fragment>
                            );
                          })}

                          {modifiersFilter(item?.modifiers || [], ["half2"]).map((modifier: Modifier) => {
                            const applied = modifier.mofireOptions.filter((option: ModifierOption) => option.isApplied);
                            return (
                              <React.Fragment key={modifier.modifierId}>
                                {applied.length > 0 ? (
                                  <>{applied.map((opt: ModifierOption, index: number) => {
                                    return <span key={index} className={styles.addonItem}>{t("ItemView.RIGHT_SELECTION")} {opt.optionName}</span>;
                                  })}</>
                                ) : null}
                              </React.Fragment>
                            );
                          })}

                        </div>
                      </div>
                    </> : <></>}
                    
                    {/* Show half and half selected add-ons side by side */}
                    {modifiersFilter(item?.modifiers || [], ["half1customs"]).reduce((count, modifier: Modifier) => {
                    return count + modifier.mofireOptions.filter((option: ModifierOption) => option.isApplied).length;
                    }, 0) > 0 ? 
                    <div className={styles.selectedAddons} style={{ marginTop: '10px' }}>
                        <h5>{t('ItemView.LEFT_SIDE_CUSTOMIZATION')}:</h5>
    
                      <div className={styles.addOnsList}>
                        {modifiersFilter(modifiersFilter(item?.modifiers || [], ["half1customs"]), ['base']).map((modifier: Modifier) => {
                          const applied = modifier.mofireOptions.filter((option: ModifierOption) => option.isApplied);
                          return (
                            <React.Fragment key={modifier.modifierId}>
                              {applied.length > 0 ? (
                                <>{applied.map((opt: ModifierOption, index: number) => {
                                  return <span key={index} className={`${styles.addonItem} ${styles.base}`}><BiCircle size={16} /> {opt.optionName} {t("ItemView.BASE")}</span>;
                                })}</>
                              ) : null}
                            </React.Fragment>
                          );
                        })}
                      </div>
    
                      <div className={styles.addOnsList}>
                        {modifiersFilter(modifiersFilter(item?.modifiers || [], ["half1customs"]), ['add']).map((modifier: Modifier) => {
                          const applied = modifier.mofireOptions.filter((option: ModifierOption) => option.isApplied);
                          return (
                            <React.Fragment key={modifier.modifierId}>
                              {applied.length > 0 ? (
                                <>{applied.map((opt: ModifierOption, index: number) => {
                                  return <React.Fragment key={index}>
                                    <CustomTooltip
                                      overlayContent={opt.optionName || ''}
                                      placement="top"
                                      scrollElement={null}
                                    >
                                      <span className={styles.addonItem}>+ {opt.quantity > 1 ? `${opt.quantity} x ` : ''} 
                                        {opt.optionName.substring(0, 20) + (opt.optionName.length > 20 ? '...' : '')}
                                      </span>
                                    </CustomTooltip>
                                  </React.Fragment>;
                                })}</>
                              ) : null}
                            </React.Fragment>
                          );
                        })}

                        {modifiersFilter(modifiersFilter(item?.modifiers || [], ["half1customs"]), ['ingredient', 'removal']).map((modifier: Modifier) => {
                          // const isIngredientRemoval = modifier.modifierName.toLowerCase().includes("ingred");
                          const removed = modifier.mofireOptions.filter((option: ModifierOption) => option.isApplied);
                          return (
                            <React.Fragment key={modifier.modifierId}>
                              {removed.length > 0 ? (
                                <>{removed.map((opt: ModifierOption, index: number) => {
                                  return <React.Fragment key={index}>
                                    <CustomTooltip
                                      overlayContent={opt.optionName || ''}
                                      placement="top"
                                      scrollElement={null}
                                    >
                                      <span className={`${styles.addonItem} ${styles.removable}`}>- {opt.quantity > 1 ? `${opt.quantity} x ` : ''} 
                                        {opt.optionName.substring(0, 20) + (opt.optionName.length > 20 ? '...' : '')}
                                      </span>
                                    </CustomTooltip>
                                  </React.Fragment>;
                                })}</>
                              ) : null}
                            </React.Fragment>
                          );
                        })}
    
                      </div>
                    </div>: <></>}

                    {modifiersFilter(item?.modifiers || [], ["half2customs"]).reduce((count, modifier: Modifier) => {
                    return count + modifier.mofireOptions.filter((option: ModifierOption) => option.isApplied).length;
                    }, 0) > 0 ?  
                    <div className={styles.selectedAddons}>
                      <h5>{t('ItemView.RIGHT_SIDE_CUSTOMIZATION')}:</h5>
    
                      <div className={styles.addOnsList}>
                        {modifiersFilter(modifiersFilter(item?.modifiers || [], ["half2customs"]), ['base']).map((modifier: Modifier) => {
                          const applied = modifier.mofireOptions.filter((option: ModifierOption) => option.isApplied);
                          return (
                            <React.Fragment key={modifier.modifierId}>
                              {applied.length > 0 ? (
                                <>{applied.map((opt: ModifierOption, index: number) => {
                                  return <span key={index} className={`${styles.addonItem} ${styles.base}`}><BiCircle size={16} /> {opt.optionName} {t("ItemView.BASE")}</span>;
                                })}</>
                              ) : null}
                            </React.Fragment>
                          );
                        })}
                      </div>
    
                      <div className={styles.addOnsList}>
                        {modifiersFilter(modifiersFilter(item?.modifiers || [], ["half2customs"]), ['add']).map((modifier: Modifier) => {
                          const applied = modifier.mofireOptions.filter((option: ModifierOption) => option.isApplied);
                          return (
                            <React.Fragment key={modifier.modifierId}>
                              {applied.length > 0 ? (
                                <>{applied.map((opt: ModifierOption, index: number) => {
                                  return <React.Fragment key={index}>
                                    <CustomTooltip
                                      overlayContent={opt.optionName || ''}
                                      placement="top"
                                      scrollElement={null}
                                    >
                                      <span className={styles.addonItem}>+ {opt.quantity > 1 ? `${opt.quantity} x ` : ''} 
                                        {opt.optionName.substring(0, 20) + (opt.optionName.length > 20 ? '...' : '')}
                                      </span>
                                    </CustomTooltip>
                                  </React.Fragment>;
                                })}</>
                              ) : null}
                            </React.Fragment>
                          );
                        })}

                        {modifiersFilter(modifiersFilter(item?.modifiers || [], ["half2customs"]), ['ingredient', 'removal']).map((modifier: Modifier) => {
                          // const isIngredientRemoval = modifier.modifierName.toLowerCase().includes("ingred");
                          const removed = modifier.mofireOptions.filter((option: ModifierOption) => option.isApplied);
                          return (
                            <React.Fragment key={modifier.modifierId}>
                              {removed.length > 0 ? (
                                <>{removed.map((opt: ModifierOption, index: number) => {
                                  return <React.Fragment key={index}>
                                    <CustomTooltip
                                      overlayContent={opt.optionName || ''}
                                      placement="top"
                                      scrollElement={null}
                                    >
                                      <span className={`${styles.addonItem} ${styles.removable}`}>- {opt.quantity > 1 ? `${opt.quantity} x ` : ''} 
                                        {opt.optionName.substring(0, 20) + (opt.optionName.length > 20 ? '...' : '')}
                                      </span>
                                    </CustomTooltip>
                                  </React.Fragment>;
                                })}</>
                              ) : null}
                            </React.Fragment>
                          );
                        })}
    
                      </div>
                    </div>: <></>}
                  </> : <></>}

                  </div>;
                })) :<>
                {/* <button 
                  id={`combo-option-${index}-item-select-button`} 
                  className={styles.dropdownSelector} 
                  onClick={() => {
                    handleSetSelectOption(index, '');
                  
                    event({
                      action: 'combo_option_select_button_clicked',
                      category: 'engagement',
                      label: `Combo Option Select Button Clicked: ${option.optionDescription}`,
                    });
                  }}
                  data-id="option-select-button"
                  style={{ paddingRight: '15px'}}
                  >
                  {(option.minSelection > 1 ? `${t("ItemView.SELECT")} ${remainingSelections} ${t("ItemView.MORE_ITEMS")}` : t("ItemView.SELECT_AN_ITEM"))} 
                  <Image src="/assets/images/arrow-left.svg" alt="Select" width={16} height={16} style={{ transform: 'rotate(270deg)' }} />
                </button> */}
              </>}

              {remainingSelections > 0 && (
                <button 
                  id={`combo-option-${index}-item-select-button`} 
                  className={styles.dropdownSelector} 
                  onClick={() => {
                    handleSetSelectOption(index,'');
                    
                    event({
                      action: 'combo_option_select_button_clicked',
                      category: 'engagement',
                      label: `Combo Option Select Button Clicked: ${option.optionDescription}`,
                    });
                  }}
                  data-id="option-select-button"
                  style={{ paddingRight: '15px'}}
                  >
                  {t("ItemView.SELECT") + ' ' + remainingSelections + ' ' + t("ItemView.MORE_ITEMS")}
                  <Image src="/assets/images/arrow-left.svg" alt="Select" width={16} height={16} style={{ transform: 'rotate(270deg)' }} />
                </button>
              )}

            </div>
          </div>
        )
        })}

        {/* <div className={styles.optionGroup} style={{ marginTop: '16px' }}>
          <h2>{t('ItemView.ADDITIONAL_NOTES')}</h2>
          <textarea 
            id='item-view-additional-notes'
            className={styles.notesInput} 
            placeholder={t('ItemView.ADD_SPECIAL_INSTRUCTIONS')}
            value={notes || ''}
            onChange={(e) => {
              if(e.target.value.length > notesCharLimit) {
                return;
              }

              setNotes(e.target.value);
            }}
            onFocus={() => setInputOnFocus(true)}
            onBlur={() => setInputOnFocus(false)}
          />
          <div className={styles.charCount}>{notes ? notes.length : 0}/{notesCharLimit}</div>
        </div> */}

        {!isComboCompleted && <div className={styles.incompleteBanner}>
          <p>{t('ItemView.PLEASE_COMPLETE_YOUR_SELECTIONS')}</p>
        </div>}

        {(hasHalfandHalf && missingEitherSideCount != 0)?<div className={styles.incompleteBanner}>
          <p>{t('ItemView.PLEASE_COMPLETE_YOUR_HALF_AND_HALF_PIZZA')}</p>
        </div>:""}

        {isComboCompleted && <div className={styles.priceSummary}>
          <small className={styles.priceDetailsLabel}>{t('ItemView.PRICE_DETAILS')}</small>
          <div className={styles.priceContainer}>
            <div className={styles.priceRow}>
              {t('ItemView.SUBTOTAL')}
              <span>{formatCurrency(subtotalPrice , selectedComboItem?.amount?.currency || 'USD')}</span>
            </div>
            
            <div className={` ${styles.priceRow} ${styles.discountRow}`}>
              <span className={styles.discountLabel}>{t('ItemView.COMBO_DISCOUNT')}
                {comboItemObj?.applyMode === "discount" ? <label className={styles.discountBadge}>
                  {(comboItemObj?.amountType === "amount" ? formatCurrency((comboDiscount), (comboItemObj?.amount?.currency || 'USD')) + ' Off' :
                  (comboItemObj?.amountType === "percentage" ? ((comboItemObj?.amount?.amount || 0) + '% Off') : '') )}
                </label> : null}
              </span>
              <span>-{formatCurrency((comboDiscount), comboItemObj?.amount?.currency || 'USD')}</span>
            </div>

            {additionalFee > 0 && <div className={styles.priceRow}>
              {t('ItemView.ADDITIONAL_FEES')}
              <span>{formatCurrency(additionalFee*(selectedComboItem?.quantity || 1), selectedComboItem?.amount?.currency || 'USD')}</span>
            </div>}

            {/* {fixedModifierTotal > 0 && <div className={styles.priceRow}>
              <span className={styles.fixedModifierLabel}>{t('ItemView.MODIFIER_CHARGES')}</span>
              <span>{formatCurrency(fixedModifierTotal, selectedComboItem?.amount?.currency || 'USD')}</span>
            </div>} */}

            <div className={styles.priceRow + ' ' + styles.totalRow}>
              <span className={styles.totalLabel}>{t('ItemView.TOTAL')}</span><span>{totalPriceFormatted()}</span>
            </div>
          </div>
        </div>}

        {!selectedComboItem?.isSoldOut && comboItemObj && <div className={styles.bottomButtons + (isBottomSheet ? ' ' + styles.withBottomNav : '')}>
            {companyDetails?.allowDealItemQty && <div className={styles.quantitySelector}>
              <button 
                id={`combo-quantity-decrease-button`}
                className={styles.quantityButton} 
                onClick={() => {
                  handleSetDealQuantity(parseInt(selectedComboItem?.quantity.toString() || "1") - 1)
                
                  event({
                    action: 'combo_quantity_decrease_button_clicked',
                    category: 'engagement',
                    label: `Combo Quantity Decrease Button Clicked: New Quantity ${parseInt(selectedComboItem?.quantity.toString() || "1") - 1}`,
                  });
                }}
                disabled={((selectedComboItem?.quantity || 1) === 1) || !isComboCompleted}
            >
              <Minus size={16} />
            </button>
            <span className={styles.quantity}>{selectedComboItem?.quantity || 1}</span>
            <button 
              id={`combo-quantity-increase-button`}
              className={styles.quantityButton} 
              onClick={() => {
                if((selectedComboItem?.allowOrderItemQuantities ?? false) && (selectedComboItem?.orderItemMaxQuantity || 0) > 0 && (Number(selectedComboItem?.orderItemMaxQuantity) || 0) <= (Number(selectedComboItem?.quantity) || 1)){
                  alertService.warn(t('ItemView.MAX_LIMIT_REACHED', { maxLimit: (selectedComboItem?.orderItemMaxQuantity || 1) }));
                  return;
                }

                handleSetDealQuantity(parseInt(selectedComboItem?.quantity.toString() || "1") + 1)
                
                event({
                  action: 'combo_quantity_increase_button_clicked',
                  category: 'engagement',
                  label: `Combo Quantity Increase Button Clicked: New Quantity ${parseInt(selectedComboItem?.quantity.toString() || "1") + 1}`,
                });
              }}
              disabled={!isComboCompleted}
            >
              <Plus size={16} />
            </button>
          </div>}

          <button id={`combo-add-to-cart-button`} 
            onClick={() => {
              handleAddToCart();
              
              event({
                action: 'combo_add_to_cart_button_clicked',
                category: 'engagement',
                label: `Combo Add to Cart Button Clicked: Combo Name ${selectedComboItem?.dealName}`,
              });
            }} 
            className={styles.addButton}
            disabled={!isComboCompleted || selectedComboItem?.isSoldOut || (hasHalfandHalf && missingEitherSideCount != 0 )}>
            <Plus size={16} /> {t("ItemView.ADD_TO_CART")} {isComboCompleted && totalPrice > 0 ? ` ${totalPriceFormatted()}` : ''}
          </button>
        </div>}

      </div>
      </div>

      {/* Pizza Customization Sheet */}
      <BottomSheet 
        show={showPizzaSheet}
        showHeader={true}
        onHide={() => setShowPizzaSheet(false)}
        onReset={() => handleResetSelectedOption()} 
        title={(selectedOption ? `${selectedOption.optionDescription}` : '')}
      >
        <span className={styles.selectionInfo}>
          {(selectedOption?.minSelection || 1) === (selectedOption?.maxSelection || 1) ?
            t('ItemView.COMBO_SELECT_EXACT', { count: (selectedOption?.minSelection || 1) }) :
            t('ItemView.COMBO_SELECT_LIMITS', { min: (selectedOption?.minSelection || 1), max: (selectedOption?.maxSelection || 1) })}
        </span>
        <div className={styles.optionGrid}>
          {isLoadingPizzaSheetItems ? (
            //Show skeleton cards while loading
            <PizzaOptionSkeleton count={6} />
          ) : (
            // Show actual items once loaded
            selectedOption && selectedOption.items && selectedOption.items.length > 0 && (
              selectedOption.items.map((item, index) => {
                const defaultVariation = item.variations ? item.variations.find(variation => variation.isApplied) : null;
            
            return(
              <div className={`${styles.optionCard} ${(item.isSoldOut || (defaultVariation?.isSoldOut || false)) ? styles.soldOut : '' }`} key={index} onClick={() => handleSetOptionItem(index, !item.isApplied)}>
                <Form.Check
                  id={`combo-option-${index}-${(selectedOption?.minSelection || 1) > 1 ? "checkbox" : "radio"}`}
                  type={(selectedOption?.minSelection || 1) > 1 ? "checkbox" : "radio"}
                  className={styles.checkmark}
                  checked={item.isApplied || false}
                  onChange={() => {}}
                  disabled={item.isSoldOut || (defaultVariation?.isSoldOut || false)}
                />
                <div className={styles.optionImage}>
                  <Image 
                    key={item?.imageUrls?.[0]?.imageUrl}
                    src={item?.imageUrls?.[0]?.imageUrl || '/assets/images/placeholder.png'}
                    alt={item?.itemName} 
                    width={80} 
                    height={80}
                    priority={true}
                    loading="eager"
                    placeholder='blur'
                    blurDataURL="/assets/images/placeholder.png"/>
                </div>
                {/* <span className={styles.optionTitle}>{item.itemName}</span> */}
                <span className={styles.optionTitle}>
                  {item.itemName?.length > 25 ? (
                    <CustomTooltip
                        placement="auto"
                        overlayContent={item.itemName}
                        scrollElement={null}
                        >
                        {item.itemName.substring(0, 25) + (item.itemName?.length > 25 ? '...' : '')}
                        </CustomTooltip>
                  ) : (
                        item.itemName
                      )}

                      <span className={styles.mealPrepContainer}>
                        <span>
                          <CustomTooltip
                            placement="auto"
                            scrollElement={null}
                            overlayContent={item?.isVegetarian ? t('VEGETARIAN') : t('NON_VEGETARIAN')}
                          >
                            {/* <div className={styles.mealPrep + (item?.isVegetarian ? ` ${styles.veg}` : '')}>
                              <span className={styles.dot}></span>
                            </div> */}
                            <div className={styles.mealPrep  + (item?.isVegetarian === null ? `${styles.hidden}`
                              : `${item?.isVegetarian ? ` ${styles.veg}` : ''}`)}>
                              <span className={styles.dot}></span>
                            </div>
                          </CustomTooltip>
                        </span>
                        {item?.itemDescription.length>0 && 
                          <MoreVertical size={21} color="#273525ff" style={{paddingBottom: '0px'}} onClick={(e) => {
                            e.stopPropagation();
                            setShowDescriptionIndex(showDescriptionIndex === index ? null : index);
                          }}/>
                        }
                      </span>
                      {showDescriptionIndex === index && (
                        <span className={styles.comboItemDescription}>
                          <RichTextViewer html={item?.itemDescription} />
                        </span>
                      )}
                  <span className={styles.priceSizeRow}>

                    {(item.isSoldOut || (defaultVariation?.isSoldOut || false)) && <span className={styles.soldOutLabel}>{t('ItemView.SOLD_OUT')}</span>}
                    {!((item.isSoldOut || (defaultVariation?.isSoldOut || false)) ? styles.soldOut : '') && <span className={styles.optionPrice + ' ' + ((item.isSoldOut || (defaultVariation?.isSoldOut || false)) ? styles.soldOut : '')}>
                      (+{item.variations.filter(variation => variation.isApplied).map(variation => formatCurrency((variation?.variationPrice?.amount || 0), (variation?.variationPrice?.currency || 'USD')))})
                    </span>}
                    {defaultVariation && defaultVariation?.variationName.length > 0 && <span className={styles.optionVariationName + ' ' + ((item.isSoldOut || (defaultVariation?.isSoldOut || false)) ? styles.soldOut : '')}>
                      {defaultVariation?.variationName}
                    </span>}
                  </span>

                  {(item.isApplied && (selectedOption?.minSelection || 1) !== (selectedOption?.maxSelection || 1)) && <div className={styles.priceQuantity} onClick={(e) => e.stopPropagation()}>
                    <div className={styles.quantityControl}>
                      {!item.isSoldOut && <Button 
                        id={`cart-item-quantity-decrease-button-${index}`}
                        variant="outline-secondary" 
                        size="sm"
                        data-id={`cart-item-quantity-decrease-button`}
                        onClick={(e) => {
                          e.stopPropagation();

                          if(!item.isSoldOut) {
                            handleQuantityChange(-1, index);

                            event({
                              action: 'cart_item_quantity_decrease_button_clicked',
                              category: 'engagement',
                              label: `Cart Item Quantity Decrease Button Clicked: ${item?.itemName || ''}`
                            });
                          }
                        }}
                      >
                        <AiOutlineMinus />
                      </Button>}
                      <span>{parseFloat((item as ItemObj)?.quantity.toString()) || 1}</span>
                      {!item.isSoldOut && <Button 
                        id={`cart-item-quantity-increase-button-${index}`}
                        variant="outline-secondary" 
                        size="sm"
                        data-id={`cart-item-quantity-increase-button`}
                        onClick={(e) => {
                          e.stopPropagation();
                          
                          if(!item.isSoldOut) {
                            if((item?.allowOrderItemQuantities ?? false) && (item?.orderItemMaxQuantity ?? 0) && (Number(item?.quantity) || 0) >= (Number(item?.orderItemMaxQuantity) ?? 0)){
                              alertService.warn(t('ItemView.MAX_LIMIT_REACHED', { maxLimit: (item?.orderItemMaxQuantity || 1) }));
                              return;
                            }

                            handleQuantityChange(1, index);

                            event({
                              action: 'cart_item_quantity_increase_button_clicked',
                              category: 'engagement',
                              label: `Cart Item Quantity Increase Button Clicked: ${item?.itemName || ''}`
                            });
                          }
                        }}
                      >
                        <AiOutlinePlus />
                      </Button>}
                    </div>
                  </div>}

                </span>
              </div>
            );
            })
            )
          )}

        </div>
        <div className={styles.buttonGroup}>
          {selectedOptionIndex !== null && (
            <>
              <button id={`combo-close-button`} onClick={() => setShowPizzaSheet(false)} className={`${styles.button} ${styles.secondary}`}>{t('ItemView.CLOSE')}</button>
              {selectedOptionIndex > 0 && (
                <button 
                  id={`combo-previous-option-button`} 
                  onClick={() => handleSetSelectOption(selectedOptionIndex - 1,'')} 
                  className={`${styles.button} ${styles.primary}`}
                  >{t('ItemView.PREVIOUS')}</button>
              )}
              {selectedOptionIndex < ((selectedComboItem?.options.length || 0) - 1)? (<>
                <button 
                  id={`combo-next-option-button`} 
                  onClick={() => handleSetSelectOption(selectedOptionIndex + 1,'')} 
                  className={`${styles.button} ${styles.primary}`}
                  disabled={(totalOptionAppliedQuantity < (selectedOption?.minSelection || 1))}
                  >{t('ItemView.NEXT')}</button>
              </>): <>
                {(selectedComboItem?.dealCategory || '').toLowerCase().includes('buy more') ? (<>
                  {/* <button className={styles.cancelButton} onClick={() => {setShowPizzaSheet(false);}}>{t('ItemView.CLOSE')}</button> */}
                  <button 
                    id={`combo-apply-button`} 
                    onClick={() => setShowPizzaSheet(false)} 
                    className={`${styles.button} ${styles.primary}`}
                    disabled={(totalOptionAppliedQuantity < (selectedOption?.minSelection || 1))}
                    >
                      {t('ItemView.ADD')} ({totalOptionAppliedQuantity}/{selectedOption?.maxSelection || 1})
                    </button></>
                ): <>
                  {/* <button className={styles.cancelButton} onClick={() => {setShowPizzaSheet(false);}}>{t('ItemView.CLOSE')}</button> */}
                  <button 
                    id={`combo-close-button`} 
                    onClick={() => setShowPizzaSheet(false)} 
                    className={`${styles.button} ${styles.primary}`}
                    disabled={(totalOptionAppliedQuantity < (selectedOption?.minSelection || 1))}
                    >{t('ItemView.FINISH')} {/* ({selectedOption?.items.filter(item => item.isApplied).length}/{selectedOption?.minSelection || 1}) */}</button>
                </>}
              </>}
            </>
          )}
        </div>
      </BottomSheet>
      
      {/* Customize Bottom Sheet */}
      <CustomizeSelector
        isHalfAndHalf={false}
        isBottomSheet={isBottomSheet}
        isShowDietaryOptions={true}
        showCustomize={showCustomize}
        showingTabId={showingTabId}
        currentStepCount={currentErrorIndex + 1}
        fullStepCount={validErrorCount}
        ItemNameForAlert={errorQueue.length > 0 ? selectedOptionItem?.itemName : undefined}
        setShowCustomize={setShowCustomize}
        setPauseNextStep={setPauseNextStep}
        modifiers={selectedOptionItem?.modifiers || []}
        onAddToCart={handleAddToCart} 
        // modifiers={selectedOptionItem?.modifiers ? [...selectedOptionItem.modifiers] : []}
        // totalPrice={totalPrice.toString()}
        setModifiers={(newModifiers) => {
        setSelectedOptionItem(prev => {
          // console.log("prev", prev?.modifiers);
          // console.log("newModifiers", newModifiers);
          if (!prev) return prev;
          
          // Merge: update only modifiers present in newModifiers, keep others unchanged
          const updatedModifiers = (prev.modifiers || []).map(existingMod => {
            const newMod = newModifiers.find(nm => nm.modifierId === existingMod.modifierId);
            return newMod || existingMod;
          });
          
          return {
            ...prev,
            modifiers: updatedModifiers
          };
        });

        setSelectedComboItem(prev => {
          if (!prev) return prev;
            const updatedCombo = { ...prev };
            updatedCombo.options.forEach(opt => {
              opt.items.forEach(item => {
                if (item.itemUniqueId === selectedOptionItem?.itemUniqueId) {
                  // Merge: update only modifiers present in newModifiers, keep others unchanged
                  item.modifiers = (item.modifiers || []).map(existingMod => {
                    const newMod = newModifiers.find(nm => nm.modifierId === existingMod.modifierId);
                    return newMod || existingMod;
                  });
                }
              });
            });
            return updatedCombo;
          });
        }}
        totalPrice={totalPriceFormatted()}
        handleModifierChange={handleModifierChange}
        resetModifiers={() => resetSelectedOptionItem()}
      />
      <BottomSheet 
        show={isComboOption}
        onHide={() => setIsComboOption(false)}
        onReset={() => setIsComboOption(false)} 
        title={t("ItemView.CUSTOMIZE_YOUR_ITEM")}
        showHeader={!isComboHalf}
      >
        {/* <ItemView loadedItemDetails={ selectedOptionItem?selectedOptionItem: null} isHalfAndHalf={true} isBottomSheet={true} isComboHalfAndHalf={isComboHalf} toggleBottomSheet={() => setIsComboOption(false)} totalPriceInc={totalPriceFormatted()} modifiers={selectedOptionItem?.modifiers || []}/> */}
        <ItemView 
          loadedItemDetails={ selectedOptionItem?selectedOptionItem: null}
          isHalfAndHalf={true}
          isBottomSheet={true}
          isComboHalfAndHalf={isComboHalf}
          isShowComboOption={isComboOption}
          ItemNameForAlert={showAlert}
          toggleBottomSheet={() => setIsComboOption(false)}
          onModifierChange={handleModifierChange}
          handleSlideChange={handleSlideChange}
          totalPriceInc={totalPriceFormatted()}
          setModifiers={(newModifiers) => {
            setSelectedOptionItem(prev => {
              if (!prev) return prev;
              
              const updatedModifiers = (prev.modifiers || []).map(existingMod => {
                const newMod = newModifiers.find(nm => nm.modifierId === existingMod.modifierId);
                return newMod || existingMod;
              });
              
              return {
                ...prev,
                modifiers: updatedModifiers
              };
            });

            setSelectedComboItem(prev => {
              if (!prev) return prev;
                const updatedCombo = { ...prev };
                updatedCombo.options.forEach(opt => {
                  opt.items.forEach(item => {
                    if (item.itemUniqueId === selectedOptionItem?.itemUniqueId) {
                      item.modifiers = (item.modifiers || []).map(existingMod => {
                        const newMod = newModifiers.find(nm => nm.modifierId === existingMod.modifierId);
                        return newMod || existingMod;
                      });
                    }
                  });
                });
                return updatedCombo;
              });
            }}
        />
      </BottomSheet>

      {/* Cart Success Bottom Sheet */}
      <ModalWrapperSheet
        show={showSuccessSheet}
        onClose={() => setShowSuccessSheet(false)}
      >
        <div className={cartsuccessstyles.illustration}>
          <Lottie animationData={itemAdded} loop={false} />
        </div>

        <div className={cartsuccessstyles.textContent}>
          <h2 className={cartsuccessstyles.title}>Item Added to Cart!</h2>
          <p className={cartsuccessstyles.description}>
            We&apos;ve added it to your cart. Ready to check out now, or want to keep shopping? We&apos;re here when you&apos;re ready.
          </p>
        </div>

        <div className={cartsuccessstyles.buttons}>
            <Link href={"/cart"+cartId} id="success-view-cart-link" className={cartsuccessstyles.viewCart}>
                <button className={cartsuccessstyles.viewCart} onClick={() => {
                  setShowSuccessSheet(false);
                  router.push('/cart' + cartId);
                }}>
                    View Cart
                </button>
            </Link>
            <Link href="/menu/all" id="success-continue-shopping-link" className={cartsuccessstyles.continueShopping}>
                <button className={cartsuccessstyles.continueShopping} onClick={(e) => {
                  e.preventDefault();
                  setShowSuccessSheet(false);

                  if(isBottomSheet) {
                    (toggleBottomSheet as () => void)();
                  } else{
                    router.push('/menu/all');
                  }
                }}>
                    Continue Browsing
                </button>
            </Link>
        </div>
      </ModalWrapperSheet>

    </div>
  </RemoveScroll>);
}
